// extracted by mini-css-extract-plugin
export var linkText = "_mp-0";